import { Link } from "react-router-dom";
import { ExternalLink, LogOut } from "lucide-react";
import { Logo } from "../brand/Logo";

export const DashboardShell = ({ tabs, tab, setTab, subtitle, footer, onLogout, children, testId }) => (
  <div className="min-h-screen bg-paper lg:grid lg:grid-cols-[272px_1fr]" data-testid={testId}>
    <aside className="bg-ink text-white lg:sticky lg:top-0 lg:h-screen lg:overflow-y-auto">
      <div className="flex items-center justify-between px-5 py-5 lg:block">
        <Logo tone="light" className="h-8" testId={`${testId}-logo`} />
        <p className="hidden pt-3 font-mono text-xs uppercase tracking-[0.14em] text-leaf lg:block">{subtitle}</p>
        <button onClick={onLogout} className="inline-flex items-center gap-2 text-sm text-white/80 hover:text-white lg:hidden" data-testid={`${testId}-logout-mobile`}>
          <LogOut className="h-4 w-4" /> Salir
        </button>
      </div>
      <nav className="flex gap-1 overflow-x-auto px-3 pb-3 lg:flex-col lg:overflow-visible lg:pb-6" aria-label="Panel">
        {tabs.map(([id, label, Icon, badge]) => (
          <button
            key={id}
            onClick={() => setTab(id)}
            data-testid={`${testId}-tab-${id}`}
            className={`flex shrink-0 items-center gap-3 rounded-xl px-3.5 py-2.5 text-left text-sm font-medium transition-colors ${
              tab === id ? "bg-leaf text-ink" : "text-white/80 hover:bg-white/5 hover:text-white"
            }`}
          >
            <Icon className="h-4 w-4" /> <span className="flex-1">{label}</span>
            {badge ? <span className={`rounded-full px-2 py-0.5 font-mono text-[10px] ${tab === id ? "bg-ink text-white" : "bg-coral text-white"}`}>{badge}</span> : null}
          </button>
        ))}
      </nav>
      <div className="hidden border-t border-white/10 px-5 py-5 lg:block">
        {footer}
        <div className="mt-3 flex items-center gap-4">
          <Link to="/" target="_blank" className="inline-flex items-center gap-1.5 text-sm text-white/85 hover:text-leaf" data-testid={`${testId}-view-site`}>
            <ExternalLink className="h-4 w-4" /> Ver sitio
          </Link>
          <button onClick={onLogout} className="inline-flex items-center gap-1.5 text-sm text-white/85 hover:text-coral" data-testid={`${testId}-logout`}>
            <LogOut className="h-4 w-4" /> Salir
          </button>
        </div>
      </div>
    </aside>
    <main className="min-w-0 px-5 py-8 sm:px-8 lg:px-12 lg:py-12">{children}</main>
  </div>
);
